import ImportedDataOverview from './ImportedDataOverview';

const ImportOverviewWrapper = ({ overviewData, file }) => (
  <ImportedDataOverview overviewData={overviewData} file={file} />
);

export default ImportOverviewWrapper;
